import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
 
const CommonCard = ({ icon, title, value, btn = "", btnClick }) => {
    const renderIcon = () => {
        if (!icon) return null;
        if (typeof icon === 'string') {
            return <img src={icon} className="card-icon" alt="icon" />;
        }
        const IconComponent = icon;
        return <IconComponent className="card-icon" />;
    };
    return (
        <div className="card">
            <div className="card-top">
                {renderIcon()}
                {btn && (
                    <button className="filter-btn" onClick={() => btnClick(title)}>
                        {btn}
                        <span><FontAwesomeIcon icon={faAngleRight} /></span>
                    </button>
                )}
            </div>
            <div className="card-title">{title}</div>
            <div className="card-value">{value}</div>
        </div>
    );
};
 
export default CommonCard;